// assets/embla-init.js

window.setupEmblaOnResize = function setupEmblaOnResize() {
  const QUERY = '(max-width: 64rem)'
  const mediaQuery = window.matchMedia(QUERY)

  function toggleEmbla() {
    document.querySelectorAll('.embla').forEach((emblaRoot) => {
      const isDesktopEnabled = emblaRoot.hasAttribute('data-embla-desktop')
      const isSimple = emblaRoot.hasAttribute('data-embla-simple')
      const shouldEnable = isDesktopEnabled || mediaQuery.matches

      if (shouldEnable && isSimple) {
        if (emblaRoot.dataset.emblaInitialized) return
        const viewportNode = emblaRoot.querySelector('.embla__viewport')
        if (!viewportNode || typeof EmblaCarousel !== 'function') return

        const prevButtonNode = emblaRoot.querySelector('.embla__prev')
        const nextButtonNode = emblaRoot.querySelector('.embla__next')
        const dotsContainer = emblaRoot.querySelector('.embla__dots')
        const emblaApi = EmblaCarousel(viewportNode, { loop: true })

        // arrows
        prevButtonNode?.addEventListener('click', () => emblaApi.scrollPrev(), {
          passive: true,
        })
        nextButtonNode?.addEventListener('click', () => emblaApi.scrollNext(), {
          passive: true,
        })

        // dots
        if (dotsContainer) {
          const slideCount = emblaApi.slideNodes().length
          dotsContainer.innerHTML = ''
          const dots = Array.from({ length: slideCount }, (_, index) => {
            const dot = document.createElement('button')
            dot.type = 'button'
            dot.className =
              'bg-black rounded-full border-2 transition-all transition-colors duration-300 w-xs h-xs border-gold active:border-gold-700 active:bg-gold-700 cursor-pointer hover:bg-gold-900'
            dot.setAttribute('aria-label', `Go to slide ${index + 1}`)
            dotsContainer.appendChild(dot)
            return dot
          })
          const updateDots = () => {
            const selected = emblaApi.selectedScrollSnap()
            dots.forEach((dot, i) => {
              dot.classList.toggle('bg-gold', i === selected)
              dot.classList.toggle('bg-black', i !== selected)
            })
          }
          dots.forEach((dot, i) =>
            dot.addEventListener('click', () => emblaApi.scrollTo(i), {
              passive: true,
            }),
          )
          emblaApi.on('select', updateDots)
          updateDots()
        }

        emblaRoot.dataset.emblaInitialized = 'true'
        emblaRoot._emblaApi = emblaApi
      } else {
        if (emblaRoot.dataset.emblaInitialized && emblaRoot._emblaApi) {
          emblaRoot._emblaApi.destroy()
          emblaRoot.dataset.emblaInitialized = ''
          emblaRoot._emblaApi = null
        }
      }
    })
  }

  // run now and on MQ changes
  toggleEmbla()
  mediaQuery.addEventListener('change', toggleEmbla)
}

// auto-run on first load
window.addEventListener('DOMContentLoaded', () => window.setupEmblaOnResize())
